import { render } from "./AddControlPage.vue?vue&type=template&id=a4fc7fe2&ts=true"
import script from "./AddControlPage.vue?vue&type=script&lang=ts"
export * from "./AddControlPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__